/** 할인권 발행(68) — 브랜드·기간으로 할인권을 골라 「확인」한 결과(표 HTML 포함)를 저장 */
export const DISCOUNT_VOUCHER_TYPE = 68;

export const isDiscountVoucherType = (apvType: number): boolean =>
  apvType === DISCOUNT_VOUCHER_TYPE;

export const DISCOUNT_VOUCHER_MISSING_MESSAGE =
  '할인권 발행 정보가 선택되지 않았습니다.';

/** 「확인」으로 확정한 할인권 — 저장 attributes 와 같은 모양 */
export type DiscountVoucherState = {
  brandCode: string;
  brandName: string;
  shopCode: string | null;
  shopName: string | null;
  voucherNumber: string;
  voucherIssueHtml: string | null;
  discountItemDetailsHtml: string | null;
};

const text = (v: unknown): string | null =>
  typeof v === 'string' && v.trim() ? v : null;

/** 저장 attributes → 상태. 할인권 번호가 없으면 null */
export const parseDiscountVoucherAttributes = (
  attributes: Record<string, unknown> | null | undefined,
): DiscountVoucherState | null => {
  const voucherNumber = text(attributes?.voucherNumber);
  if (!attributes || !voucherNumber) return null;
  return {
    brandCode: text(attributes.brandCode) ?? '',
    brandName: text(attributes.brandName) ?? '',
    shopCode: text(attributes.shopCode),
    shopName: text(attributes.shopName),
    voucherNumber,
    voucherIssueHtml: text(attributes.voucherIssueHtml),
    discountItemDetailsHtml: text(attributes.discountItemDetailsHtml),
  };
};

export const buildDiscountVoucherAttributes = (
  state: DiscountVoucherState | null | undefined,
) => (state?.voucherNumber ? { ...state } : null);

export const checkDiscountVoucherBeforeSave = (
  state: DiscountVoucherState | null | undefined,
): string | null =>
  state?.voucherNumber ? null : DISCOUNT_VOUCHER_MISSING_MESSAGE;

export const discountVoucherKey = (
  state: DiscountVoucherState | null | undefined,
) => state?.voucherNumber ?? '';

/** 레거시 number_format — 빈 값은 0, 숫자가 아니면 원문 그대로 */
export const formatVoucherNumber = (value: string | null | undefined) => {
  if (value === null || value === undefined || value === '') return '0';
  const n = Number(value);
  return Number.isFinite(n) ? n.toLocaleString('en-US') : value;
};
